// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';

@Injectable({
	providedIn: 'root'
})
export class HelpService {
	private helpUrl = new BehaviorSubject<string>('');

	public helpUrl$: Observable<string> = this.helpUrl.asObservable();



	constructor(private appConfigService: AppConfigService) { }

	listenHelpLinkUrl(): Observable<string> {
		return this.helpUrl;
	}

	// Update help link in right-menu to input URL.
	updateHelpLinkUrl(url: string): void {
		this.helpUrl.next(url);
	}

	// Lookup the help URL for this page (feature) and if we know it use that, else use default from config file.
	updateHelpLink(feature: string): void {
		let url: string = this.appConfigService.getConfig().baseHelpURL;
		if (feature) {
			url = `${url}/${feature}`;
		}
		this.helpUrl.next(url);
	}

}
